import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const checkCollapse = () => {
      const collapsed = localStorage.getItem('sidebarCollapsed') === 'true';
      setIsCollapsed(collapsed);
    };

    checkCollapse();

    const handleSidebarToggle = () => checkCollapse();
    window.addEventListener('sidebarToggle', handleSidebarToggle);
    window.addEventListener('storage', checkCollapse);

    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle);
      window.removeEventListener('storage', checkCollapse);
    };
  }, []);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-ink-100">
      {/* Top command bar spans full width */}
      <Navbar />

      <div className="flex flex-1 min-h-0 overflow-hidden">
        <Sidebar />

        <main
          className={`flex-1 overflow-y-auto overflow-x-hidden transition-smooth ${
            isCollapsed ? 'lg:ml-[68px]' : 'lg:ml-[232px]'
          }`}
        >
          <div className="mx-auto w-full max-w-[1580px] p-3 sm:p-4 lg:p-5">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
